import { render, staticRenderFns } from "./WalletEth.vue?vue&type=template&id=41cbfccd&scoped=true"
import script from "./WalletEth.vue?vue&type=script&lang=js"
export * from "./WalletEth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cbfccd",
  null
  
)

export default component.exports